import { PayloadAction } from 'interfaces/action'
import { createPayloadAction } from 'helpers/actionsHelpers'
import { AnalyticsEvent } from 'interfaces/analytics'


export const TRACK_UI_EVENT = 'TRACK_UI_EVENT' as const
export type TrackUIEventAction = PayloadAction<typeof TRACK_UI_EVENT, AnalyticsEvent>
export const trackUIEventAction = (payload: AnalyticsEvent): TrackUIEventAction => createPayloadAction(TRACK_UI_EVENT, payload)

export type AnalyticsAction =
  | TrackUIEventAction


export default AnalyticsAction
